import { Link, Stack, Typography, Fade, Box } from "@mui/material";
import { Application, URLS } from "../../../config/const/enums.js";
import useSharedData from "../../../hooks/useSharedData";
import {
	Section,
	OneColumnStack,
	TitleSubTitle,
	RHFSelect,
	RHFTextField,
	RHFDateTextField,
	NotificationCard,
} from "@arp/react-ndbx";

//TODO: PUT BACK
import AccordionPanel from "../../coding/AccordionPanel.jsx";
import { yourDetailsPersonalFieldNames } from "../../../config/pageInfo/pageFieldName.js";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import {
	checkIfItContainsAnyValue,
	isAdditionalPolicyPresent,
} from "../../../utilities/preQualificationUtils.js";
import { useWatch } from "react-hook-form";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import useTheme from "@mui/material/styles/useTheme";
//TODO: PUT BACK/
//----------------------------------------------------------------

const AdditionalOwnerAccordion = ({
	titleItems,
	reset,
	resetField,
	setValue,
	dataSet,
	person,
	getValues,
	control,
}) => {
	const {
		errors: [errors],
		handleAdditionalPolicyHolder: [handleAdditionalPolicyHolder],
		showAdditionalPolicyHolder: [showAdditionalPolicyHolder],
		isAdditionalSameAsPrimary: [isAdditionalSameAsPrimary],
	} = useOutletContext();
	const { pdsUrl } = useSharedData();

	const theme = useTheme();
	const [isAccordionOpen, setIsAccordionOpen] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [
		additionalPolicyHolderDefaultTitle,
		setAdditionalPolicyHolderDefaultTitle,
	] = useState("");
	const [resetAllField, setResetAllField] = useState(false);

	const additionalPolicyTitleWatch = useWatch({
		control,
		name: yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_TITLE,
	});
	const additionalPolicyFirstNameWatch = useWatch({
		control,
		name: yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_FIRSTNAME,
	});
	const additionalPolicySurnameWatch = useWatch({
		control,
		name: yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_SURNAME,
	});
	const additionalPolicyDOBWatch = useWatch({
		control,
		name: yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_DOB,
	});

	const handleAccordionClick = () => {
		setExpanded(!expanded);
	};
	useEffect(() => {
		let returnValueCheck = checkIfItContainsAnyValue(
			additionalPolicyTitleWatch,
			additionalPolicyFirstNameWatch,
			additionalPolicySurnameWatch,
			additionalPolicyDOBWatch
		);
		if (returnValueCheck) {
			setIsAccordionOpen(true);
		} else {
			resetAllFieldsOfAdditionalPolicyHolder();
			setIsAccordionOpen(false);
		}
	}, [
		additionalPolicyTitleWatch,
		additionalPolicyFirstNameWatch,
		additionalPolicySurnameWatch,
		additionalPolicyDOBWatch,
	]);

	const resetAdditionalPolicyHolder = () => {
		setExpanded(!expanded);
		setIsAccordionOpen(false);
		setResetAllField(true);
		resetAllFieldsOfAdditionalPolicyHolder();
	};

	const resetAllFieldsOfAdditionalPolicyHolder = () => {
		// reset the fields and close the accordion
		resetField(yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_TITLE);
		setValue(yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_TITLE, "");
		setAdditionalPolicyHolderDefaultTitle("");
		resetField(
			yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_FIRSTNAME
		);
		setValue(
			yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_FIRSTNAME,
			""
		);
		resetField(yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_SURNAME);
		setValue(
			yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_SURNAME,
			""
		);
		resetField(yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_DOB);
		setValue(
			yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_DOB,
			undefined
		);
	};

	useEffect(() => {
		handleAdditionalPolicyHolder(isAccordionOpen);
	}, [isAccordionOpen]);

	useEffect(() => {
		if (isAdditionalPolicyPresent(dataSet)) {
			setIsAccordionOpen(true);
			setExpanded(true);
		}
	}, []);

	useEffect(() => {
		const formData = getValues();
		if (formData.personOne_firstName) {
			setTimeout(async () => {
				setValue(
					yourDetailsPersonalFieldNames(person).FIRST_NAME,
					formData.personOne_firstName,
					{ shouldValidate: true }
				);
			}, 100);
		}
	}, [showAdditionalPolicyHolder]);

	useEffect(() => {
		if (isAdditionalSameAsPrimary) {
			var targetElement = document.getElementById(
				"error-additional-same-primary-holder"
			);
			targetElement.scrollIntoView({
				behavior: "smooth",
			});
		}
	}, [isAdditionalSameAsPrimary]);

	return (
		<AccordionPanel
			mt={{ sm: 2, md: 6 }}
			// width={{ md: 470 }}
			label="Are you interested in an additional Policy Owner?"
			stackMargin={{ xs: 2, sm: 0, md: 0 }}
			summaryMargin={{ xs: 0, sm: 0 }}
			topBorderOpacity={0}
			onClickHandler={handleAccordionClick}
			expanded={expanded}
		>
			{[
				<>
					{isAdditionalSameAsPrimary && (
						<Section
							mb={4}
							sx={{
								pl: { xs: 1, sm: 8 },
								pr: { xs: 1, sm: 8 },
							}}
							id="error-additional-same-primary-holder"
						>
							<Fade in={true} timeout={500}>
								<Box>
									<NotificationCard
										cardType="error"
										title=""
										message={
											"Additional policy holder details can't be the same as the Primary policy holder."
										}
									/>
								</Box>
							</Fade>
						</Section>
					)}
					<Section>
						<TitleSubTitle
							title="If you’d like to have an additional Policy Owner"
							variant={"h5-bold"}
							sx={{ mb: 2, mt: 2 }}
						></TitleSubTitle>
						<Section textAlign={"left"}>
							{dataSet?.application === Application?.ONLINE ? (
								<Typography variant="p2" sx={{ mb: 2 }}>
									You’ve the option of completing this quote and purchasing it
									as a single Life Insured and filling out the additional Policy
									Owner details below.
								</Typography>
							) : (
								<Typography variant="p2" sx={{ mb: 2 }}>
									You’ve the option of completing this quote and purchasing it
									as a single Life Insured and letting me know the details of
									the additional Policy Owner.
								</Typography>
							)}
						</Section>
						{/* Adding the Additional policy holder form */}
						<OneColumnStack align="left" sx={{ mb: 2 }}>
							<TitleSubTitle
								title="Additional Policy Owner Details"
								variant={"h5-bold"}
								sx={{ mb: 2, mt: 2 }}
							></TitleSubTitle>
							<Section
								id="title-select-section"
								md={12}
								mt={3}
								align="left"
								sx={{ outline: "0px blue solid" }}
							>
								<RHFSelect
									name={
										yourDetailsPersonalFieldNames(person)
											.ADDITIONAL_HOLDER_TITLE
									}
									label="Title"
									variant="standard"
									items={titleItems ? titleItems : []}
									defaultValue={
										resetAllField === true
											? ""
											: getValues(
													yourDetailsPersonalFieldNames(person)
														.ADDITIONAL_HOLDER_TITLE
												) || dataSet.additionalPolicyHolderTitle
									}
								/>
							</Section>
							<Section md={12} mt={{ sm: 2, md: 4 }}>
								<RHFTextField
									name={
										yourDetailsPersonalFieldNames(person)
											.ADDITIONAL_HOLDER_FIRSTNAME
									}
									defaultValue={dataSet.additionalPolicyHolderFirstName}
									className="subvariant-text-input"
									variant="standard"
									label="First name"
									sx={{ textTransform: "uppercase" }}
								/>
							</Section>
							<Section md={12} mt={{ sm: 2, md: 4 }}>
								<RHFTextField
									name={
										yourDetailsPersonalFieldNames(person)
											.ADDITIONAL_HOLDER_SURNAME
									}
									defaultValue={dataSet.additionalPolicyHolderSurname}
									className="subvariant-text-input"
									variant="standard"
									label="Surname"
								/>
							</Section>
							<Section
								md={12}
								mt={{ sm: 2, md: 4 }}
								align="left"
								sx={{ outline: "0px blue solid" }}
							>
								<RHFDateTextField
									name={
										yourDetailsPersonalFieldNames(person).ADDITIONAL_HOLDER_DOB
									}
									defaultValue={dataSet.additionalPolicyHolderDOB}
									variant="standard"
									label="Date of birth"
									showErrorCard={true}
								/>
							</Section>
							<Section
								onClick={resetAdditionalPolicyHolder}
								justifyContent="center"
								display="flex"
								alignItems="center"
								mt={{ xs: 4, md: 8 }}
								mb={{ xs: 3, md: 4 }}
							>
								<RemoveCircleIcon
									style={{
										color: `${theme.palette.action.PrimaryAction600}`,
										cursor: "pointer",
									}}
								/>
								<Typography
									variant="p3-link-bold"
									sx={{ fontSize: 14, cursor: "pointer" }}
								>
									Remove additional policy holder
								</Typography>
							</Section>
						</OneColumnStack>
						{/* Additional policy holder ends */}
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								<b>Note:</b> By completing the additional owner details, you and
								the additional Policy Owner are agreeing to the following
								important information and have read and understood the{" "}
								{/* <Link href={URLS.PDS_URL} target="_blank"> */}
								<Link href={pdsUrl} target="_blank">
									Product Disclosure Statement
								</Link>{" "}
								. This additional Policy Owner won’t be a Life Insured under the
								policy.
							</Typography>
						</Section>
						{/* <TitleSubTitle
							title="If you’d like to have an additional Policy Owner"
							variant={"h5-bold"}
							sx={{ mb: 2, mt: 2 }}
						></TitleSubTitle> */}
						{/* <Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Complete the{" "}
								<Link
									href={URLS.ADDITIONAL_POLICY_OWNER_FORM_URL}
									target="_blank"
								>
									Addition of Policy Owner Form
								</Link>
								. Note this additional Policy Owner won’t be a Life Insured
								under the policy. You may do this now or at a future time, this
								form is available on our{" "}
								<Link href={URLS.POLICY_OUTCOME} target="_blank">
									website.
								</Link>
							</Typography>
						</Section> */}
						<TitleSubTitle
							title="Important information about Policy Owners:"
							variant={"h5-bold"}
							sx={{ mb: 2, mt: 2 }}
						></TitleSubTitle>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Where there are two Policy Owners under the policy, we'll pay
								the death benefit to the surviving Policy Owner.
							</Typography>
						</Section>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Note: The request of one Policy Owner will bind all Policy
								Owners. There's a maximum of two Policy Owners per Life
								Insurance Policy.
							</Typography>
						</Section>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								A Policy Owner will have all rights over the policy and may
								request changes on behalf of any other Policy Owner.
							</Typography>
						</Section>
						<Section textAlign={"left"}>
							<Typography variant="p2" sx={{ mb: 2 }}>
								Requested changes may include, but not limited to:
								<ul>
									<li>decrease of cover(s)</li>
									<li>removal of cover(s) or a Policy Owner</li>
									<li>cancellation of the policy</li>
									<li>updating contact details</li>
								</ul>
							</Typography>
						</Section>
						{dataSet?.application === Application?.CONTACT_CENTER && (
							<Section textAlign={"left"}>
								<Typography variant="p2-bold">
									{`<Confirm Applicant and Additional Owner agreement>`}
								</Typography>
							</Section>
						)}
					</Section>
				</>,
			]}
		</AccordionPanel>
	);
};

export default AdditionalOwnerAccordion;
